document.addEventListener( 'pageLoad', setupVideoPlayer );

function setupVideoPlayer( e ) {
	const frames = document.querySelectorAll( 'iframe' );
	frames.forEach( ( frame ) => {
		let video = false;
		if ( frame ) {
			video = frame.closest( '.video-container' )
		}
		if ( video ) {
			const plyr = new Plyr( video, {
				captions: { disabled: true, active: false, language: 'auto', update: false },
				settings: ['captions', 'quality', 'speed', 'loop'],
				controls: ['clickToPlay', 'play', 'play-large', 'progress', 'mute', 'volume', 'settings', 'fullscreen'],
				autoplay: false,
				loadSprite: true,
				vimeo: { background: true, byline: false, portrait: false, title: true, speed: false, transparent: false },
				youtube: { noCookie: false, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1 }
			} );
			console.log( 'plyr', plyr.elements.container )

			// plyr.embed.disableTextTrack().then( function ( e ) {
			// 	console.log( 'disable', e )
			// 	// the track was disabled
			// } ).catch( function ( error ) {
			// 	// an error occurred
			// } );

			plyr.on( "ready", ( e ) => {

				console.log( 'ready', e )
				// setTimeout( () => { plyr.embed.disableTextTrack(); }, 2000 );
				plyr.captions.active = false;
			} );
		}
	} )

}